import React from 'react';
import Select from "@/components/molecules/Select";
import { useState } from "react";

interface Option {
  id: string | number;
  label: string;
  entities: { id: string | number; name: string, status: boolean; }[];
}

interface FilterOption {
  id: string;
  label: string;
  options: { value: string | number; label: string; entities?: { id: string | number; name: string }[] }[];
  selected?: (string | number)[];
}

interface AutoInvoiceFilterProps {
  filters: FilterOption[];
  selectedFilters: { [key: string]: (string | number)[] | null };
  onFilterChange: (filterId: string, value: (string | number)[] | null) => void;
}

const AutoInvoiceFilter: React.FC<AutoInvoiceFilterProps> = ({ filters, selectedFilters, onFilterChange }) => {
  const [isVisibleEntity, setIsVisibleEntity] = useState<boolean>(false);
  const [entityOptions, setEntityOptions] = useState<any[]>([]);
  const searchEnabled = ['account_id'];

  const handleChange = (filterId: string, value: (string | number)[]) => {
    onFilterChange(filterId, value.length ? value : null);

    if (value.length && filterId === 'account_id') {
      setIsVisibleEntity(true)
      const accountFilter = filters.find(filter => filter.id === 'account_id');
      if (accountFilter) {
        const filteredOptions = accountFilter.options
          .filter(option => value.includes(option.value.toString()))
          .map(option => ({
            id: option.value,
            label: option.label,
            entities: option.entities,
          }));
       
          setEntityOptions(filteredOptions);
      } else {
        setEntityOptions([]);
        onFilterChange('entity_id', null);
      }

    } 
    
    if (value.length == 0 && filterId === 'account_id'){
      setIsVisibleEntity(false);
      setEntityOptions([]);
      onFilterChange('entity_id', null);
    }
  };

  const getSelectOptions = (options: Option[]) => {
    return options.flatMap(option => {
      return option.entities.map(entity => ({
        label: entity.name,
        value: entity.id.toString(),
        disabled: false,
      }))
    });
  };

  return (
    <div className="mb-4 flex space-x-4 items-end">
      {filters.map(filter => (
        
        <div key={filter.id} className="flex flex-col w-52">
          <label htmlFor={filter.id} className="mr-2 text-sm">{filter.label}:</label>
          <Select
            multiple
            options={
              filter.options.map((option) => ({
                label: option.label,
                value: option.value.toString(),
              })) || []
            }
            value={filter.selected || selectedFilters[filter.id] || []}
            onChange={(value) => handleChange(filter.id, value)}
            className= 'w-100'
            enabledSearch={searchEnabled.includes(filter.id)}
    
          />
          
        </div>
      ))}
      {isVisibleEntity && (
        <div className="flex flex-col w-60">
          <label htmlFor="entities" className="mr-2 text-sm">By Client Entity:</label>
          <Select
            multiple
            options={getSelectOptions(entityOptions)}
            value={selectedFilters['entity_id'] || []}
            onChange={(value) => onFilterChange('entity_id', value)}
            className= 'w-100'
            enabledSearch={true}
          />
        </div>
      )}
    </div>
  );
};

export default AutoInvoiceFilter;
